import { useState } from "react";
import { Button, Grid } from "@mui/material";
import Container from "../../components/Generics/Container";
import TextFieldGeneric from "../../components/Generics/TextFieldGeneric";
import { SaveOutlined } from "@mui/icons-material";
import { Plus } from "@phosphor-icons/react";
import postoCombustivelApi from "../../api/postoCombustivelApi";

import { useSnack } from "../../redux/snack/snackHooks";
import { PostoCombutivel } from "../../model/entities/PostoCombustivel";
import PostoCombustivelField from "../../components/fields/PostoCombustivelField";

type Props = {};

const PostosCombustivelPage: React.FC<Props> = (props) => {
  const [loading, setLoading] = useState(false);
  const mostrarSnack = useSnack();
  const [postoSelecionado, setPostoSelecioando] =
    useState<PostoCombutivel | null>(null);

  const salvar = async () => {
    try {
      if (!postoSelecionado) return;
      setLoading(true);
      if (!postoSelecionado.id) {
        await postoCombustivelApi.insert(postoSelecionado);
        mostrarSnack(
          `Novo posto ${postoSelecionado.nome} cadastrado.`,
          "success"
        );
        setPostoSelecioando(null);
        setLoading(false);
        return;
      }

      await postoCombustivelApi.update(postoSelecionado.id, postoSelecionado);

      setPostoSelecioando(null);
      setLoading(false);
    } catch (erro: any) {
      setLoading(false);
      mostrarSnack(
        `Errro ao atualizar informações do posto ${postoSelecionado?.nome}`,
        "error"
      );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container page loading={loading}>
        <Grid container spacing={2}>
          {(!postoSelecionado || !postoSelecionado.id) && (
            <Grid item xs={12} style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                children={"Novo posto de combustível"}
                startIcon={<Plus />}
                onClick={() =>
                  setPostoSelecioando({ ...new PostoCombutivel() })
                }
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <PostoCombustivelField
              idPosto={postoSelecionado?.id}
              posto={postoSelecionado}
              setPosto={(user) => {
                setPostoSelecioando(user);
              }}
            />
          </Grid>

          {postoSelecionado && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <h2>Configurações do posto {postoSelecionado.nome}</h2>
              </Grid>

              <Grid item xs={12}>
                <TextFieldGeneric
                  label="Nome"
                  value={postoSelecionado.nome}
                  onChange={(value) => {
                    setPostoSelecioando({
                      ...postoSelecionado,
                      nome: value,
                    });
                  }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextFieldGeneric
                  label="Email"
                  value={postoSelecionado.email}
                  onChange={(value) => {
                    setPostoSelecioando({
                      ...postoSelecionado,
                      email: value,
                    });
                  }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextFieldGeneric
                  label="Cidade/Destino"
                  value={postoSelecionado.cidadeDetino}
                  onChange={(value) => {
                    setPostoSelecioando({
                      ...postoSelecionado,
                      cidadeDetino: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={6} />

              <Grid item xs={12} style={{ textAlign: "center" }}>
                <Button
                  children={"Salvar"}
                  onClick={() => salvar()}
                  variant="contained"
                  startIcon={<SaveOutlined />}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  );
};

export default PostosCombustivelPage;
